const SensorErrorIcon = ({ className, title }) => (
  <svg
    aria-hidden={title ? undefined : 'true'}
    className={className}
    fill='none'
    height='23'
    role={title ? 'img' : undefined}
    viewBox='0 0 23 23'
    width='23'
    xmlns='http://www.w3.org/2000/svg'
  >
    {title && <title>{title}</title>}
    <circle
      cx='11.5'
      cy='11.5'
      r='10.75'
      stroke='#FF3152'
      strokeWidth='1.5'
    />
    <path
      d='M11.5 5.75V12.25'
      stroke='#FF3152'
      strokeLinecap='round'
      strokeWidth='1.5'
    />
    <circle
      cx='11.5'
      cy='16.25'
      fill='#FF3152'
      r='1.15'
    />
  </svg>
)

export default SensorErrorIcon
